if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();
        this.quantity = this.querySelector('quantity-input');

        const debouncedOnChange = debounce((event) => {
          if (parseInt(event.target.value) === 0) {
            this.startQueue(event.target.dataset.index, parseInt(event.target.value));
          } else {
            this.validateQuantity(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.caculationPrice();
        this.lastActiveInputId = null;
        const pageParams = new URLSearchParams(window.location.search);
        window.pageNumber = decodeURIComponent(pageParams.get('page') || '');
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (
            event.source === 'quick-add' ||
            (event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index))) ||
            (event.cartData.variant_id && !(event.cartData.variant_id === parseInt(this.dataset.index)))
          ) {
            return;
          }
          // If its another section that made the update
          this.onCartUpdate().then(() => {
            this.listenForActiveInput();
            this.listenForKeydown();
          });
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      getInput() {
        return this.querySelector('quantity-input input');
      }

      getinitialContent() {
        return this.querySelector('.quantity__input').value - 1
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      listenForActiveInput() {
        if (!this.classList.contains('hidden') && this.getInput()) {
          this.getInput().addEventListener('focusin', (event) => event.target.select());
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        if (this.getInput()) {
          this.getInput().addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              this.getInput().blur();
              this.isEnterPressed = true;
            }
          });
        }
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('');
          },
          { once: true }
        );
      }

      onCartUpdate() {
        return new Promise((resolve, reject) => {
          fetch(`${this.getSectionsUrl()}?section_id=${this.closest('.collection').dataset.id}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector(
                `#quick-add-bulk-${this.dataset.id}-${this.closest('.collection').dataset.id}`
              );
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML;
              }
              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        });
      }

      caculationPrice() {
        if (this.querySelector('.quantity__input')) {
          let quantity_v = this.querySelector('.quantity__input').value,
          button_v = this.querySelector('.quick-add-bulk--add');

          if (this.dataset.type == 'product') {
            if (this.closest('product-info').querySelector('.product-form__input input[type=radio]:checked')) {
              let price_v = this.closest('product-info').querySelector('.product-form__input input[type=radio]:checked').dataset.price;
              if (quantity_v > 1) {
                let price_total = quantity_v * price_v,
                  format_price = `$${(price_total / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                if (this.closest('product-info').querySelector('.price--total .price__regular .price-item')) this.closest('product-info').querySelector('.price--total .price__regular .price-item').innerText = format_price + ' ' + Shopify.currency.active;
              }
            } else {
              if (quantity_v > 1) {
                let price_v = parseFloat(this.closest('product-info').querySelector('.price--normal').dataset.price);
                console.log(price_v);

                let price_total = quantity_v * price_v,
                  format_price = `$${(price_total / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                if (this.closest('product-info').querySelector('.price--total .price__regular .price-item')) this.closest('product-info').querySelector('.price--total .price__regular .price-item').innerText = format_price + ' ' + Shopify.currency.active;
              }
            }
          }

          if (quantity_v > 0) {
            button_v.style.display = "none";
          } else {
            button_v.style.display = "flex";
          }
        }
      }

      updateMultipleQty(items) {
        this.getinitialContent();
        this.selectProgressBar().classList.remove('hidden');

        const ids = Object.keys(items);
        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            const str = Object.values(items).join(", ");
            if (!parsedState.errors) {
              this.renderSections(parsedState, ids);
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
              this.caculationPrice();
              if (document.querySelector('#cart-notification')) {
                document.querySelector('#cart-notification').classList.add('active');
                setTimeout(() => {
                  document.querySelector('#cart-notification').classList.remove('active');
                }, 5000)
              }

              let dataID = this.getAttribute('data-index');
              if (document.querySelectorAll(`#Quantity-${dataID}`)) {
                document.querySelectorAll(`#Quantity-${dataID}`).forEach((item) => {
                  item.value = str;
                })
              }
              if (document.querySelector('b2b-cart-drawer')) document.querySelector('#cart-icon-bubble').click();
            } else {
              if (this.querySelector('.quick-add-bulk__error')) {
                this.querySelector('.quick-add-bulk__error .quick-add-bulk_error-text').innerHTML = parsedState.errors;
                this.querySelector('.quantity__input').value = this.querySelector('.quantity__input').getAttribute('value');
              }
              Toastify({
                text: 'Product ' + this.getAttribute('data-product-name') + " can't add to cart",
                duration: 3000,
                newWindow: true,
                autoClose: 6000,
                gravity: "bottom",
                position: "center", 
                stopOnFocus: true,
                style: {
                  background: "#fd817a",
                },
                onClick: function(){}
              }).showToast();
            }
          })
          .catch((e) => {
            // Commented out for now and will be fixed when BE issue is done https://github.com/Shopify/shopify/issues/440605;
            console.log(e);
          })
          .finally(() => {
            this.selectProgressBar().classList.add('hidden');
            this.requestStarted = false;
            this.caculationPrice();
          });
      }

      //quota code tuanda
      setErrorMessage(message = null, ids) {
        if (ids.length > 0) {
          const errorElement = document.querySelector(`#card-product-error-${ids[0]}`);
          if (errorElement) errorElement.querySelector(".card-product__error-text").textContent = message;
        }
      }
      //end quota code tuanda

      getSectionsToRender() {
        return [
          {
            id: `quick-add-bulk-${this.dataset.id}-${this.closest('.collection-quick-add-bulk').dataset.id}`,
            section: this.closest('.collection-quick-add-bulk').dataset.id,
            selector: `#quick-add-bulk-${this.dataset.id}-${this.closest('.collection-quick-add-bulk').dataset.id}`,
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'CartDrawer',
            selector: '#CartDrawer',
            section: 'cart-drawer',
          },
        ];
      }

      renderSections(parsedState, ids) {
        const intersection = this.queue.filter((element) => ids.includes(element.id));
        if (intersection.length !== 0) return;
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (
            sectionElement &&
            sectionElement.parentElement &&
            sectionElement.parentElement.classList.contains('drawer')
          ) {
            parsedState.items.length > 0
              ? sectionElement.parentElement.classList.remove('is-empty')
              : sectionElement.parentElement.classList.add('is-empty');

            setTimeout(() => {
              document.querySelector('#CartDrawer-Overlay').addEventListener('click', this.cart.close.bind(this.cart));
            });
          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        if (this.isEnterPressed) {
          this.querySelector(`#Quantity-${this.lastActiveInputId}`).select();
        }

        this.listenForActiveInput();
        this.listenForKeydown();
      }
    }
  );
}
